var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 18,
    height: 18,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H10C10.8284 2.5 11.5 3.17157 11.5 4V10C11.5 10.8284 10.8284 11.5 10 11.5H4C3.17157 11.5 2.5 10.8284 2.5 10V4Z",
    fill: "white",
    stroke: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8C6.5 7.17157 7.17157 6.5 8 6.5H14C14.8284 6.5 15.5 7.17157 15.5 8V14C15.5 14.8284 14.8284 15.5 14 15.5H8C7.17157 15.5 6.5 14.8284 6.5 14V8Z",
    fill: "white",
    stroke: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.df0482d2c7b74a26380322038bb52a4e.svg";
export { ForwardRef as ReactComponent };